// extracted by mini-css-extract-plugin
export default {"cards":"EjercicioCards_cards__1ioz0"};